<template>
  <v-btn
    :append-icon="mdiArrowRight"
    :color="secondary ? secondaryColor || 'primary' : primaryColor || 'primary'"
    :href="value.href"
    :target="hrefTarget(value.href)"
    :variant="secondary ? 'outlined' : undefined"
    exact
    size="large"
  >
    {{ value.action }}</v-btn
  >
</template>

<script setup lang="ts">
import type { DirectusSchema } from '#root/types/content'
import { mdiArrowRight } from '@mdi/js'
import { hrefTarget } from '#root/lib/utils'

withDefaults(
  defineProps<{
    primaryColor?: string
    secondary?: boolean
    secondaryColor?: string
    value: DirectusSchema['cta']
  }>(),
  {
    primaryColor: undefined,
    secondary: false,
    secondaryColor: undefined
  }
)
</script>
